module.exports = __webpack_public_path__ + "static/img/xgdh1.60dbf97.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/newestqianniu/xgdh1.png
// module id = 77
// module chunks = 0